import "./App.css";
import React, {useEffect} from 'react';
import Home from './Home.js';
import Admin from './Admin.js';
import Attendee from './Attendee.js';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import {useAuthState, useWindowSize} from './reusableHooks';

function App() {
  const user = useAuthState();
  const windowSize = useWindowSize();
  const vh = windowSize?.height;
  
  useEffect(() => {
    if(typeof vh !== 'undefined') document.body.style.height = `${vh}px`;
    return () => {};
  }, [windowSize])
  
  return (
    <>
    {!user?.flagged &&
    <Router>
      <div className="App">
        <Switch>
          <Route path="/" exact render={routeProps => <Home thisUser={user}/>}/>
          <Route path="/admin" render={routeProps => <Admin thisUser={user}/>}/>
          <Route path="/attendee" render={routeProps => <Attendee thisUser={user}/>}/>
        </Switch>
      </div>
    </Router>
   }
   {user?.flagged && 
    <div className="flagged-user-warning text-danger d-flex justify-content-center align-items-center"> 
        <h3 className="text-center">You've been flagged and can no longer access this page.</h3>
    </div>
   }
  </>
  );
}

export default App;
